<div class="loader">
  <span class="loader_circle" [ngClass]="{ 'loader_circle--sm': isSmall }"></span>
  <span class="loader_circle" [ngClass]="{ 'loader_circle--sm': isSmall }"></span>
  <span class="loader_circle" [ngClass]="{ 'loader_circle--sm': isSmall }"></span>
  <ng-content></ng-content>
</div>
